module.exports = __webpack_public_path__ + "img/trophy-gold.f4b79e9a.svg";